import { Box } from '@mui/joy';
import AllApplicantsView from 'components/admin/AllApplicantsView';

const Applicants: React.FC = () => {
  return (
    <Box className="min-h-screen bg-[#f4f4f4] flex flex-col px-4 py-6 lg:px-10">
      <AllApplicantsView />
    </Box>
  );
}

export default Applicants;